import React, { memo } from 'react';

const CustomSpeedometer = ({
    minValue = 0,
    maxValue = 100,
    value = 50,
    needleColor = 'black',
    startColor = 'green',
    endColor = 'red',
    segments = 10,
    textColor = 'black',
    width = 270,
    height = 164,
    currentValueText = `${value} Km/h`
}) => {

    const textHeight = 20;
    const radius = (height - textHeight) * 0.7;
    const strokeWidth = 22;
    const segmentAngle = 180 / segments;
    const valueAngle = ((value - minValue) / (maxValue - minValue)) * 180;

    const interpolateColor = (value, highMax, lowMax, highColor, lowColor) => {
        const ratio = (value - lowMax) / (highMax - lowMax);
        const r = Math.floor((1 - ratio) * parseInt(lowColor.slice(1, 3), 16) + ratio * parseInt(highColor.slice(1, 3), 16));
        const g = Math.floor((1 - ratio) * parseInt(lowColor.slice(3, 5), 16) + ratio * parseInt(highColor.slice(3, 5), 16));
        const b = Math.floor((1 - ratio) * parseInt(lowColor.slice(5, 7), 16) + ratio * parseInt(highColor.slice(5, 7), 16));
        return '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
    };

    const createSegments = () => {
        let paths = [];
        for (let i = 0; i < segments; i++) {
            const segmentColor = interpolateColor(i, segments - 1, 0, endColor, startColor);
            const startAngle = (i * segmentAngle) - 180;
            const endAngle = (i + 1) * segmentAngle - 180;
            const largeArcFlag = endAngle - startAngle <= 180 ? 0 : 1;
            const startX = width / 2 + radius * Math.cos(Math.PI * startAngle / 180.0);
            const startY = height / 2 + radius * Math.sin(Math.PI * startAngle / 180.0) + 50;
            const endX = width / 2 + radius * Math.cos(Math.PI * endAngle / 180.0);
            const endY = height / 2 + radius * Math.sin(Math.PI * endAngle / 180.0) + 50;
            paths.push({ d: `M ${startX} ${startY} A ${radius} ${radius} 0 ${largeArcFlag} 1 ${endX} ${endY}`, color: segmentColor });
        }
        return paths;
    };

    const needleLength = radius - strokeWidth;
    const needleWidth = 5;

    const calculateNeedlePoints = () => {
        const topX = width / 2 - needleLength * Math.cos(Math.PI * valueAngle / 180);
        const topY = height / 2 - needleLength * Math.sin(Math.PI * valueAngle / 180) + 50;
        const leftX = width / 2 - needleWidth * Math.sin(Math.PI * valueAngle / 180);
        const leftY = height / 2 + needleWidth * Math.cos(Math.PI * valueAngle / 180) + 50;
        const rightX = width / 2 + needleWidth * Math.sin(Math.PI * valueAngle / 180);
        const rightY = height / 2 - needleWidth * Math.cos(Math.PI * valueAngle / 180) + 50;
        return `${topX},${topY} ${leftX},${leftY} ${rightX},${rightY}`;
    };

    return (
        <svg width={width} height={height}>
            {createSegments().map((segment, i) => (
                <path key={i} d={segment.d} fill="none" stroke={segment.color} strokeWidth={strokeWidth} />
            ))}
            {/* Needle */}
            <polygon
                points={calculateNeedlePoints()}
                fill={needleColor}
            />
            {/* Pivot point */}
            <circle cx={width / 2} cy={height / 2 + 50} r={needleWidth} fill={needleColor} />

            <text x={width / 2} y={height - 5} textAnchor="middle" fill={textColor} fontSize="18px" fontWeight="bold">
                {currentValueText}
            </text>
            <text x={10} y={height - 5} textAnchor="start" fill={textColor} fontSize="14px">
                {minValue} Km/h
            </text>
            <text x={width - 10} y={height - 5} textAnchor="end" fill={textColor} fontSize="14px">
                {maxValue} Km/h
            </text>
        </svg>
    );
};

export default memo(CustomSpeedometer);
